<div class="modal-header">
  <h4 class="modal-title pull-left">{{ getTitle() }}</h4>
  <button type="button" class="btn-close close pull-right fs-12" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true" class="visually-hidden font-weight-light">&times;</span>
  </button>
</div>
<div class="modal-body">
  <!-- Extra Data WO | NO -->
  @if (type === 'WO') {
    <app-data-work-order
      [isLoading]="isLoading"
      [data]="woData"></app-data-work-order>
  }

  @if (type === 'WOP') {
    <app-data-work-order-permit
      [isLoading]="isLoading"
      [data]="woData"></app-data-work-order-permit>
  }

  @if (type === 'NO') {
    <app-data-notification
      [isLoading]="isLoading"
      [data]="noData"></app-data-notification>
  }

</div>
<div class="modal-footer text-center">
  <button type="button" class="btn btn-outline-danger" (click)="cancel()">
    Close
  </button>
</div>
